import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { pxToRem } from '../setup'
import { breakpointDown } from '../utils/breakpoints'

function setupStickyBackButton(scroller)
{

  if(breakpointDown('lg')) return

  let $stickyButtonContainerAbsolute = $('.sticky-back-button.is-absolute')
  let $stickyButtonContainerSticky = $('.sticky-back-button.is-sticky')

  let topPos = Math.ceil(pxToRem(12))

  if($stickyButtonContainerAbsolute.length) {
    ScrollTrigger.create({
      trigger: '.js-sticky-button-trigger',
      start: 'top top+='+topPos,
      end: 'bottom top',
      scroller: scroller,
      scrub: true,
      //markers: true,
      onEnter: () => {
        $stickyButtonContainerAbsolute.hide()
        $stickyButtonContainerSticky.show()
      },
      onLeaveBack: () => {
        $stickyButtonContainerAbsolute.show()
        $stickyButtonContainerSticky.hide()
      },
    })
  }

}

export { setupStickyBackButton }
